import React from 'react';
import { Box, Checkbox, FormControlLabel, Grid } from '@mui/material';

const LocationSelector = ({
  get_all_location = [],
  selectedLocationIds = [],
  defaultLocation,
  handleSelectAll,
  handleLocationChange,
  searchQuery = "",
}) => {
  const isAllSelected = selectedLocationIds.length === get_all_location.length;

  const filteredLocations = get_all_location.filter((loc) =>
    loc.locationDescription.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Grid item xs={12}>
      <Box sx={{ padding: '2px 10px', borderRadius: '8px', mt: '20px' }}>
        <FormControlLabel
          control={<Checkbox checked={isAllSelected} onChange={handleSelectAll} />}
          label="Select All"
        />
        <Grid container spacing={2}>
          {filteredLocations.map((location) => (
            <Grid item xs={12} sm={4} md={2} key={location.locationId}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedLocationIds.includes(location.locationId)}
                    onChange={() => handleLocationChange(location.locationId)}
                    sx={{
                      color:
                        location.locationId === defaultLocation ? 'primary.main' : undefined,
                    }}
                  />
                }
                label={
                  <>
                    {location.locationDescription}
                    {location.locationId === defaultLocation && ' (Default)'}
                  </>
                }
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Grid>
  );
};

export default LocationSelector;
